import { connect } from 'react-redux'
import MaintenanceCasesComponent from '../components/MaintenanceCasesComponent.jsx';
import {
	forwardToFindAllMcases,
	forwardToFindMcasesByYear,
	forwardToSetMaintenanceTargetCase,
	forwardToSelectMcasesTab,
	forwardToFindProcessingMcases,
	forwardToFindExportingMcases,
	forwardToFindExportedMcases,
	forwardToFindPrintedMcases,
	forwardToFindPricePrintedMcases,
	forwardToGenerateMaintenanceCheckFileMap,
	forwardToGenerateMaintenanceCheckFileMap2,
	forwardToGenerateMaintenancePriceFileMap,
	forwardToGenerateMaintenanceSummaryFileMap,
	forwardToGenerateMaintenanceCardsFileMap,
	forwardToGenerateMaintenanceSerialFileMap,
	forwardToResetFileLinks,
	// forwardToSetMaintenanceCaseExported,
	// forwardToSetMaintenanceCaseExported2,
	// forwardToSetMaintenanceCasePrinted,
	// forwardToSetMaintenanceCasePricePrinted,
	forwardToFindCategories,
	forwardToDeleteCase,
	forwardChangeSelectedYear

} from '../actions';

const mapStateToProps = (state) => ({

	roles: state.getIn(['authReducer', 'roles']),

	//alert
	alert: state.getIn(['addMaintenanceCaseReducer', 'alert']),

	//view model
	mCaseListViewModel: state.getIn(['maintenanceCasesReducer', 'mCaseListViewModel']),

	files: state.getIn(['maintenanceCasesReducer', 'files']),

	files2: state.getIn(['maintenanceCasesReducer', 'files2']),

	cardsFiles: state.getIn(['maintenanceCasesReducer', 'cardsFiles']),

	priceFiles: state.getIn(['maintenanceCasesReducer', 'priceFiles']),

	summaryFiles: state.getIn(['maintenanceCasesReducer', 'summaryFiles']),

	serialFiles: state.getIn(['maintenanceCasesReducer', 'serialFiles']),

	//request
	mCaseListRequestModel: state.getIn(['maintenanceCasesReducer', 'mCaseListRequestModel']),
	
	selectedYear: state.getIn(['maintenanceCasesReducer', 'selectedYear']),
})

const mapDispatchToProps = (dispatch) => ({
	// findAllMcases: () => {
	// 	dispatch(forwardToFindAllMcases());
	// },
	findMcasesByYear: (year) => {
		dispatch(forwardToFindMcasesByYear(year));
	},

	resetFileLinks: () => {
		dispatch(forwardToResetFileLinks());
	},

	findProcessingMcases: () => {
		dispatch(forwardToFindProcessingMcases());
	},

	findExportingMcases: () => {
		dispatch(forwardToFindExportingMcases());
	},

	findExportedMcases: () => {
		dispatch(forwardToFindExportedMcases());
	},

	findCardsPrintedMcases: () => {
		dispatch(forwardToFindPrintedMcases());
	},

	findCardsPricePrintedMcases: () => {
		dispatch(forwardToFindPricePrintedMcases());
	},

	setTarget: (id) => {
		dispatch(forwardToSetMaintenanceTargetCase({
			value: id
		}));
	},

	onCasesTabsChange: (tabKey) => {
		dispatch(forwardToSelectMcasesTab(tabKey));
	},

	generateMaintenanceCheckFileMap: (casePk) => {
		dispatch(forwardToGenerateMaintenanceCheckFileMap(casePk));
	},

	generateMaintenanceCheckFileMap2: (casePk) => {
		dispatch(forwardToGenerateMaintenanceCheckFileMap2(casePk));
	},

	generateMaintenanceSerialFileMap: (casePk) => {
		dispatch(forwardToGenerateMaintenanceSerialFileMap(casePk));
	},

	generateMaintenancePriceFile: (casePk) => {
		dispatch(forwardToGenerateMaintenancePriceFileMap(casePk));
	},

	generateMaintenanceSummaryFile: (casePk) => {
		dispatch(forwardToGenerateMaintenanceSummaryFileMap(casePk));
	},

	generateMaintenanceCardsFile: (casePk) => {
		dispatch(forwardToGenerateMaintenanceCardsFileMap(casePk));
	},

	findCheckCategories: () => {
		dispatch(forwardToFindCategories());
	},

	handleDelete: (casePk) => {
		dispatch(forwardToDeleteCase(casePk));
	},

	changeSelectedYear: (year) => {
		dispatch(forwardChangeSelectedYear(year));
	}
})

const MaintenanceCasesContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceCasesComponent)

export default MaintenanceCasesContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceCasesContainer.jsx